/**
 * 接口地址
 * @type {string}
 */




let api_base = `https://zyzb.wolkm.cn/admproj/`


if (process.env.NODE_ENV == 'development') {
    api_base = `/admproj/`
}

export const API_BASE_URL = api_base;
